import React from 'react';
import '../LobbyIsFullModal/LobbyIsFullModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {AI_PROMO_JOIN_REASONS} from '../../../utils/aiPromo/aiPromoJoin';
import {
  TEXT_AI_LOBBY_SPECTATOR_FULL_TEXT,
  TEXT_AI_LOBBY_SPECTATOR_FULL_TITLE,
  TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TEXT,
  TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TITLE,
} from '../../../constants/text/aiMatch';

const PAGE_ID = 'AiLobbySpectatorModal';

const LOBBY_FULL_COPY = {title: TEXT_AI_LOBBY_SPECTATOR_FULL_TITLE, text: TEXT_AI_LOBBY_SPECTATOR_FULL_TEXT};
const PHASE_STARTED_COPY = {
  title: TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TITLE,
  text: TEXT_AI_LOBBY_SPECTATOR_PHASE_STARTED_TEXT,
};

// Причина входа зрителем — те же значения, что spectatorReason сервера
// (planAiPromoJoin). Начавшийся матч объясняется так же, как начавшиеся
// баны: набор закрыт, хотя места могли оставаться
const COPY_BY_REASON = {
  [AI_PROMO_JOIN_REASONS.LOBBY_FULL]: LOBBY_FULL_COPY,
  [AI_PROMO_JOIN_REASONS.PHASE_STARTED]: PHASE_STARTED_COPY,
  [AI_PROMO_JOIN_REASONS.MATCH_STARTED]: PHASE_STARTED_COPY,
};

/**
 * Вход зрителем в лобби матча против ИИ: в отличие от обычного лобби, где
 * полное лобби — отказ (LobbyIsFullModal), сюда сервер пускает зрителем
 * (joinedAsSpectator) — смотреть матч зовем всех. Модалка объясняет, почему
 * нет выбора фракции: лобби заполнено (LOBBY_FULL, по умолчанию) или набор
 * уже закрыт — идут баны и выбор фракций (PHASE_STARTED / MATCH_STARTED).
 * Оформление — как у LobbyIsFullModal.
 *
 * @param {Object} props
 * @param {Function} props.onHide
 * @param {string} [props.reason] - значение AI_PROMO_JOIN_REASONS
 */
function AiLobbySpectatorModal({onHide, reason = AI_PROMO_JOIN_REASONS.LOBBY_FULL}) {
  const {title, text} = COPY_BY_REASON[reason] || LOBBY_FULL_COPY;
  return (
    <div className="lobby-is-full-overlay" onClick={onHide} role="dialog" aria-modal="true">
      <div className="lobby-is-full-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="lobby-is-full-title">{title}</h2>
        <p className="lobby-is-full-text">{text}</p>

        <div className="main-menu-buttons lobby-is-full-buttons">
          <PageButton onClick={onHide} pageId={PAGE_ID} buttonId="hide">
            Понятно
          </PageButton>
        </div>
      </div>
    </div>
  );
}

export default AiLobbySpectatorModal;
